import React from 'react';

import LinksList from './LinksList.react';

const MenuNonAuthenticated = () => {
  const links = [
    { path: '/auth/login', title: 'Login' },
    { path: '/auth/signup', title: 'Sign up' },
  ];
  return <LinksList links={links} />;
};

export default MenuNonAuthenticated;
